import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8aa0aa2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1))
const _hoisted_3 = {
  class: "dot",
  ref: "lastDot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.loading || $props.hide)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "wave",
        class: _normalizeClass(["loader", {absolute: $props.absolute}]),
        style: _normalizeStyle({visibility: $options.visibility, top: $props.top})
      }, [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, null, 512)
      ], 6))
    : _createCommentVNode("", true)
}